import { render, staticRenderFns } from "./fileSelectorPic.vue?vue&type=template&id=1252d323&scoped=true&"
import script from "./fileSelectorPic.vue?vue&type=script&lang=js&"
export * from "./fileSelectorPic.vue?vue&type=script&lang=js&"
import style0 from "./fileSelectorPic.vue?vue&type=style&index=0&id=1252d323&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252d323",
  null
  
)

export default component.exports